export const authMeta = {
  requiresAuth: true
};
